import React,{Fragment, useState } from 'react';
import { withApollo, useQuery, useMutation } from 'react-apollo';
import Helper from '../../../Library/helper';
import translate from '../../Translations/index';
import {GET_REALTY_ATTRIBUTES,DELETE_REALTY_ATTRIBUTES} from '../Queries/realtyAttribute';
import ModalNotification from '../../../GlobalComponents/ModalNotification';
import Notification from '../../../Library/notification';
import Loading from '../../../GlobalComponents/Loading';
import Error from '../../../GlobalComponents/Error';
import edit from '../../../Public/Images/edit.svg';
import NoItems from '../../../GlobalComponents/NoItems';
import AddEditRealtyAttribute from './AddEditRealtyAttribute';
import RealtyAttributeLib from '../Library/realtyAttribute';

const RealtyAttributes = (props) => {

    const realtyAttributeLib = new RealtyAttributeLib(props);

    const [selectedRealtyAttributes,setSelectedRealtyAttributes]   = useState([]);
	const [showDeleteNotifi,setShowDeleteNotifi] = useState(false);
	const [showAdd,setShowAdd] 			         = useState(false);
    const [selectedRealtyAttributeID,setSelectedRealtyAttributeID] = useState(0);
    
    const {loading, error:getError, data:realtyAttributesData}   = useQuery(GET_REALTY_ATTRIBUTES,{
        fetchPolicy: 'cache-and-network'
    });

    const [deleteRealtyAttribute, { data,loading: deleteLoading, error: deleteError }] = useMutation(DELETE_REALTY_ATTRIBUTES,{	
		update(cache,response) {            
            
            realtyAttributeLib.updateAfterDelete(cache, response);

            let notify = new Notification();
            notify.setNotification(cache,translate.t("SuccessFullyDeleted"),true,false);
            setShowDeleteNotifi(false);
		},						
		onError(err){
            const helper = new Helper(); 
            let notify = new Notification();
            notify.setNotification(null,helper.getApolloErrorText(err),false,true,props.client);
		}
    });

    const openCloseModal = (open,realtyAttributeID) => {
        setSelectedRealtyAttributeID(realtyAttributeID);
        setShowAdd(open);
    }

    const showDelNotifi = () => {
        if(selectedRealtyAttributes.length > 0){
            setShowDeleteNotifi(true);
        }else{
            let notify = new Notification();
            notify.setNotification(null,translate.t("ItemNotSelected"),false,true,props.client);
        }
    }

    const delRealtyAttribute = (action) => {

        if(action){

            let realtyAttributeIDs = selectedRealtyAttributes.join(",");
            deleteRealtyAttribute({variables:{realtyAttributeIDs}});
        }

        setShowDeleteNotifi(false);
    }

    const initiateDeleteRealtyAttribute = (e,realtyAttributeID) => {

        var checked = e.target.checked;
        var arr = [...selectedRealtyAttributes];

        if(!checked){
            for(let i in selectedRealtyAttributes){
                if(selectedRealtyAttributes[i] == realtyAttributeID){
                    arr.splice(i,1);
                }
            }
        }else{
            arr = [realtyAttributeID,...arr];
        }

        setSelectedRealtyAttributes(arr);
  
    }

    if(getError || deleteError){
        var error = getError ? getError : deleteError;
        const helper = new Helper(); 
        error = "ERROR: " + helper.getApolloErrorText(error)
    }

    return (
        <div id="settings" className="whole-container" >
            
            <div className="row" >
                <div className="col-sm one">
                    <div className="card main">
                        
                        <div className="card-header d-flex align-items-center">
                            {translate.t("RealtyAttributes")}
                            <button className="btn btn-primary btn-thiner ml-auto" onClick={() => openCloseModal(true,0)}>{translate.t("Add")}</button>
                            <button className="btn btn-danger btn-thiner ml-2" onClick={() => showDelNotifi()}>{translate.t("DeleteSelected")}</button>
                        </div>
                        <div className="card-body">

                            {!error ?
                                <div>
                                    <div className="data-list">
                                        
                                        <div className="data-list-item header">
                                            <div className="data-list-item-content">
                                                <div>{translate.t("ItemName")}</div>
                                                <div className="text-right">{translate.t("Options")}</div>
                                            </div>
                                        </div>

                                        {realtyAttributesData && realtyAttributesData.allRealtyAttributes && realtyAttributesData.allRealtyAttributes.map((item,index) => {
                                            
                                            var checked = false;
                                            for(let i in selectedRealtyAttributes){
                                                if(selectedRealtyAttributes[i] == item.realtyAttributeID)checked = true;
                                            }

                                            return (
                                                
                                                <div key={index} className="data-list-item">
                                                    <div className="data-list-item-content categories">
                                                        <div>{item.name}</div>
                                                        <div className="text-right">
                                                            <img onClick={() => openCloseModal(true,item.realtyAttributeID)} className="edit-icon" src={edit} />
                                                            <input className="delete-checked" type="checkbox" name="deleteAthlete[]" checked={checked} onChange = {(e) => initiateDeleteRealtyAttribute(e,item.realtyAttributeID)} />
                                                        </div>
                                                    </div>
                                                </div> 
                                            )
                                            
                                        })}
                                        
                                    </div>
                                    {!loading ? 
                                        <Fragment>
                                            {realtyAttributesData && realtyAttributesData.allRealtyAttributes && realtyAttributesData.allRealtyAttributes.length == 0 &&
                                                <NoItems text={translate.t("NoItemsAddedYet")} />
                                            }
                                        </Fragment>
                                        :                                    
                                        <Loading />                                    
                                    }
                                    
                                </div>
                                :
                                <Fragment>
                                    {error &&  <Error text={error} />}
                                </Fragment>
                            }
                        </div>
                    </div>
                </div>
            </div> 	
            {showAdd &&
                <AddEditRealtyAttribute openCloseModal={openCloseModal} selectedRealtyAttributeID={selectedRealtyAttributeID} />
            }	
            {showDeleteNotifi && <ModalNotification yesNo={true} text={translate.t("RemoveItems?")} callback={delRealtyAttribute} /> }	
        </div>
    )

}

export default withApollo(RealtyAttributes);